<template>
  <div class="card mb-25 border-0 rounded-0 bg-white edit-course-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <form @submit.prevent="createNote">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Ramasseur :
              </label>
              <v-select
                class="custom-select-height"
                :options="RamassList"
                v-model="ramass"
                label="name"
                placeholder="Sélectionner un ramasseur"
              >
              </v-select>
            </div>
          </div>
          <hr />

          <div class="col-md-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <button class="btn btn-primary" type="submit" :disabled="isLoader">
                Ajouter
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script lang="ts">
import { useAppToast } from "@/composables/useAppToast";
import router from "@/router";
import api from "@/utils/axios";
import { onMounted, ref } from "vue";
import { defineComponent } from "vue";

export default defineComponent({
  setup() {
    const { showToast } = useAppToast();

    const RamassList = ref([]);
    const ramass = ref<any | null>(null);
    const isLoader = ref(false);

    onMounted(async () => {
      try {
        const response = await api.get(`/api/auth/userListPickup`);
        if (response && response.data) {
          RamassList.value = response.data;
        }
      } catch (error) {
        console.error("Error fetching ramasseurs list:", error);
      }
    });

    async function createNote() {
      if (!ramass.value) {
        showToast(
          "Champs obligatoire, Merci de remplir tous les champs",
          "error"
        );
        return;
      }

      const data = new FormData();
      data.append("user_id", ramass.value.id);
      isLoader.value = true;

      try {
        const res = await api.post(`/api/auth/newNotePoint`, data);

        if (res.data.message === "success") {
          const routeData = router.resolve({
            name: "PointageDetailsPage",
            params: {
              id: res.data.RtnNote.id,
              ref: res.data.RtnNote.note_ref,
            },
          });
          window.open(routeData.href, "_blank");
        } else {
          showToast("Erreur lors de la création du bon de suivi livreur", "error");
        }
      } catch (error) {
        showToast("Erreur lors de la création du bon de suivi livreur", "error");
      } finally {
        isLoader.value = false;
      }
    }

    return {
      RamassList,
      ramass,
      isLoader,

      createNote,
    };
  },
});
</script>
